import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"accessibility"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M12 5.5C13.2426 5.5 14.25 4.49264 14.25 3.25C14.25 2.00736 13.2426 1 12 1C10.7574 1 9.75 2.00736 9.75 3.25C9.75 4.49264 10.7574 5.5 12 5.5Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M3.25 9.625C3.25 8.72754 3.97754 8 4.875 8H19.125C20.0225 8 20.75 8.72754 20.75 9.625C20.75 10.5225 20.0225 11.25 19.125 11.25H15.25L17.3444 20.6746C17.5525 21.6114 16.8397 22.5 15.8801 22.5H14.5L12.5 15.25H11.5L9.5 22.5H8.11992C7.1603 22.5 6.44747 21.6114 6.65564 20.6746L8.75 11.25H4.875C3.97754 11.25 3.25 10.5225 3.25 9.625Z"}}]},{"tag":"g","attrs":{"id":"stroke1"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M12 5.5C13.2426 5.5 14.25 4.49264 14.25 3.25C14.25 2.00736 13.2426 1 12 1C10.7574 1 9.75 2.00736 9.75 3.25C9.75 4.49264 10.7574 5.5 12 5.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M3.25 9.625C3.25 8.72754 3.97754 8 4.875 8H19.125C20.0225 8 20.75 8.72754 20.75 9.625C20.75 10.5225 20.0225 11.25 19.125 11.25H15.25L17.3444 20.6746C17.5525 21.6114 16.8397 22.5 15.8801 22.5H14.5L12.5 15.25H11.5L9.5 22.5H8.11992C7.1603 22.5 6.44747 21.6114 6.65564 20.6746L8.75 11.25H4.875C3.97754 11.25 3.25 10.5225 3.25 9.625Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]}]};

const Accessibility = Vue.extend<IconProps>({
  name: 'AccessibilityIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'accessibility',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Accessibility;
